import { render, staticRenderFns } from "./MovementImages.vue?vue&type=template&id=48fe8cf8&"
import script from "./MovementImages.vue?vue&type=script&lang=js&"
export * from "./MovementImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports